module.exports = __webpack_public_path__ + "static/img/petronaslogo.6e37245.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/petronaslogo.png
// module id = IDyH
// module chunks = 107